import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <TopicsSection />
        <ContactSection />
        <UpdatesSection />
        <AboutSection />
        <AppSection />
        <CarouselSection />
        <RankingSection />
        <IndexSection />
        <FeaturesSection />
        <CardsSection />
        <CommentsSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}